module.exports = "<div class=\"error error-{{size}}\">\n  <div class=\"error-container\" #error>\n      <div class=\"message\" [class.errorMessage]=\"errorMessage\">\n        <strong>Si è verificato un errore</strong>\n        <br><br>\n        {{errorMessage}}\n      </div>\n  </div>\n  <div class=\"tc-content-box\" [class.isError]=\"isError\" #data>    \n      <ng-content></ng-content>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/atoms/alg-error-modal/alg-error-modal.component.html
// module id = ./src/app/components/atoms/alg-error-modal/alg-error-modal.component.html
// module chunks = main